// import {
//   Table,
//   Input,
//   DatePicker,
//   Select,
//   Form,
//   Radio,
//   Alert,
//   Row,
//   Card,
// } from "antd";
// import dayjs from "dayjs";
// import locale from "antd/es/date-picker/locale/fr_FR";
// import classes from "../../../Etablissements/Etablissements.module.css";
// import { useTranslation } from "react-i18next";

// const { Option } = Select;

// const EtapeListeApprenantsFNH = ({ form, globalData, id_session_formation ,typesession}) => {
//   const nbLignes = globalData?.nb_apprenants || 0;
//   const { t } = useTranslation();

//   const niveauScolaire = [
//     { value: "إبتدائي", label: "Primaire - إبتدائي" },
//     { value: "ثانوي", label: "Secondaire - ثانوي" },
//     { value: "جامعي", label: "Universitaire - جامعي" },
//     { value: "تكوين مهني", label: "Formation professionnelle - تكوين مهني" },
//   ];

//   const apprenantsFields = Array.from({ length: nbLignes }, (_, index) => ({
//     key: index,
//     name: index,
//   }));

//   const columns = [
//     {
//       title: "Type",
//       dataIndex: "typeIdentifiant",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "typeIdentifiant"]}
//           initialValue="cin"

//         >
//           <Radio.Group size="small" disabled={id_session_formation}>
//             <Radio.Button value="cin">CIN</Radio.Button>
//             <Radio.Button value="extrait">Extrait</Radio.Button>
//           </Radio.Group>
//         </Form.Item>
//       ),
//     },
//     {
//       title: "Nom",
//       dataIndex: "nom",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "nom"]}
//           rules={[
//             { required: true, message: t("Veuillez remplir ce champ.") },
//              {
//             validator: (_, value) => {
//               if (value && value.trim() === "") {
//                 return Promise.reject(
//                   t("Veuillez remplir ce champ.")
//                 );
//               }
//               return Promise.resolve();
//             },
//           },
//           ]}

//         >
//           <Input size="small" placeholder="Nom" disabled={id_session_formation} />
//         </Form.Item>
//       ),
//     },
//     {
//       title: "Prénom",
//       dataIndex: "prenom",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "prenom"]}
//           rules={[{ required: true, message: t("Veuillez remplir ce champ.") },
//              {
//               validator: (_, value) => {
//                 if (value && value.trim() === "") {
//                   return Promise.reject(
//                     t("Veuillez remplir ce champ.")
//                   );
//                 }
//                 return Promise.resolve();
//               },
//             },
//           ]}

//         >
//           <Input size="small" placeholder="Prénom" disabled={id_session_formation} />
//         </Form.Item>
//       ),
//     },
//     {
//   title: "Identifiant",
//   dataIndex: "identifiant",
//   width: 150,
//   render: (_, field, index) => (
//     <Form.Item
//       shouldUpdate={(prevValues, currentValues) =>
//         prevValues.apprenants?.[field.name]?.typeIdentifiant !==
//         currentValues.apprenants?.[field.name]?.typeIdentifiant
//       }
//       noStyle
//     >
//       {({ getFieldValue }) => {
//         const type =
//           getFieldValue(["apprenants", field.name, "typeIdentifiant"]) || "cin";

//         const rules = [
//           { required: true, message: "Veuillez remplir ce champ." },
//           {
//             pattern: type === "cin" ? /^\d{8}$/ : /^\d{10}$/,
//             message:
//               type === "cin"
//                 ? t("Le cin doit être au format 8 chiffres.")
//                 : t("L'extrait doit être au format 10 chiffres."),
//           },

//           {
//   validator: (_, value) => {
//     if (!value) return Promise.resolve(); // ne pas valider si champ vide

//     const allValues = getFieldValue("apprenants") || [];
//     const currentType = allValues?.[field.name]?.typeIdentifiant;

//     const isDuplicate = allValues.some((apprenant, idx) => {
//       if (idx === field.name) return false;
//       return (
//         apprenant?.identifiant === value &&
//         apprenant?.typeIdentifiant === currentType
//       );
//     });

//     return isDuplicate
//       ? Promise.reject("Identifiant déjà utilisé.")
//       : Promise.resolve();
//   },
// }
//         ];

//         return (
//           <Form.Item
//             {...field}
//             name={[field.name, "identifiant"]}
//             rules={rules}
//           >
//             <Input
//               size="small"
//               maxLength={type === "cin" ? 8 : 10}
//               placeholder="Identifiant"
//               disabled={id_session_formation}
//             />
//           </Form.Item>
//         );
//       }}
//     </Form.Item>
//   ),
// }

// ,
//     {
//       title: "Date de naissance",
//       dataIndex: "dateNaissance",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "dateNaissance"]}
//           rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}

//         >
//           <DatePicker
//             size="small"
//             locale={locale}
//             format="DD/MM/YYYY"
//             style={{ width: "100%" }}
//             disabledDate={(current) => current && current > dayjs()}
//             disabled={id_session_formation}
//           />
//         </Form.Item>
//       ),
//     },

//      typesession === "continue" &&   {
//       title: "Structure / Entreprise",
//       dataIndex: "structure",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "structure"]}
//           rules={[{ required: false},
//              {
//               validator: (_, value) => {
//                 if (value && value.trim() === "") {
//                   return Promise.reject(
//                     t("Veuillez remplir ce champ.")
//                   );
//                 }
//                 return Promise.resolve();
//               },
//             },
//           ]}

//         >
//           <Input size="small" placeholder="Structure" disabled={id_session_formation} />
//         </Form.Item>
//       ),
//     },
//     {
//       title: "Niveau",
//       dataIndex: "niveau",
//       width: 150,
//       render: (_, field) => (
//         <Form.Item
//           {...field}
//           name={[field.name, "niveau"]}
//           rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}

//         >
//           <Select
//           style={{ width: "100%" }}
//             size="small"
//             placeholder="Niveau"
//             options={niveauScolaire}
//             disabled={id_session_formation}
//           />
//         </Form.Item>
//       ),
//     },
//   ].filter(Boolean);

//   return (
//     <div>
//       <Row className={classes.listeRow}>
//         <Card
//           className={classes.listeCard}
//           style={{ marginBottom: "40px" }}
//           bordered={false}
//         >
//           <Alert
//             type="info"
//             style={{ marginTop: "20px" }}
//             message="Configuration"
//             description={`Ajout des participants`}
//             showIcon
//           />
//           <Form.List name="apprenants">
//             {(fields) => {

//               if (fields.length !== nbLignes) {
//                 const newFields = Array.from({ length: nbLignes }, (_, i) => ({
//                   typeIdentifiant: "cin",
//                 }));
//                 form.setFieldsValue({ apprenants: newFields });
//               }
//               return (
//                 <Table
//                   style={{ marginTop: "20px" }}
//                   size="small"
//                   dataSource={apprenantsFields}
//                   pagination={false}
//                   rowKey={(row) => row.key}
//                   columns={columns}
//                   scroll={{ x: "max-content" }}
//                 />
//               );
//             }}
//           </Form.List>
//         </Card>
//       </Row>
//     </div>
//   );
// };

// export default EtapeListeApprenantsFNH;

import {
  Table,
  Input,
  DatePicker,
  Select,
  Form,
  Alert,
  Row,
  Card,
  ConfigProvider,
  notification,
} from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/fr_FR";
import classes from "../../../Etablissements/Etablissements.module.css";
import { useTranslation } from "react-i18next";
import {
  checkCitizenStatusByCinDn,
  checkCitizenStatusByIdMadDn,
} from "../../../../api/extern";
import { useLoader } from "../../../../context/LoaderContext";
import { getCommuneByCodeCommune } from "../../../../context/FetchLists";
import { check_apprenant_exist } from "../../../../api/geoprod";
import { useEffect } from "react";

const { Option } = Select;
const { Search } = Input;

const EtapeListeApprenantsFNH = ({
  form,
  globalData,
  id_session_formation,
  typesession,
  id_formation,
}) => {
  const nbLignes = globalData?.nb_apprenants || 0;
  const { t } = useTranslation();
  const { setIsLoading } = useLoader();
  const niveauScolaire = [
    { value: "إبتدائي", label: "Primaire - إبتدائي" },
    { value: "ثانوي", label: "Secondaire - ثانوي" },
    { value: "جامعي", label: "Universitaire - جامعي" },
    { value: "تكوين مهني", label: "Formation professionnelle - تكوين مهني" },
  ];
  useEffect(() => {
    const currentApprenants = form.getFieldValue('apprenants') || [];
    
    if (nbLignes > currentApprenants.length) {
      const newApprenants = [...currentApprenants];
      while (newApprenants?.length < nbLignes) {
        newApprenants?.push({ typeIdentifiant: 'cin' });
      }
      form.setFieldsValue({ apprenants: newApprenants });
    }
    else if (nbLignes < currentApprenants?.length) {
      form.setFieldsValue({ apprenants: currentApprenants?.slice(0, nbLignes) });
    }
  }, [nbLignes]);
  const apprenantsFields = Array.from({ length: nbLignes }, (_, index) => ({
    key: index,
    name: index,
  }));
  
const handleSearch = async (fieldName) => {
  try {
    setIsLoading(true);

    const identifiant = form.getFieldValue([
      "apprenants",
      fieldName,
      "identifiant",
    ]);
    const dateNaissance = form.getFieldValue([
      "apprenants",
      fieldName,
      "dateNaissance",
    ]);
    const type = form.getFieldValue([
      "apprenants",
      fieldName,
      "typeIdentifiant",
    ]);

    const allApprenants = form.getFieldValue("apprenants") || [];
    const isDuplicate = allApprenants.some((apprenant, idx) => {
      if (idx === fieldName) return false; // Ne pas comparer avec soi-même
      return (
        apprenant?.identifiant === identifiant &&
        apprenant?.typeIdentifiant === type
      );
    });

    if (isDuplicate) {
      notification.warning({
        message: t("Avertissement"),
        description: "Cet identifiant est déjà utilisé par un autre apprenant",
        duration: 3,
      });
      return;
    }

    let isValid = true;
    let errors = {};

    if (!identifiant) {
      errors.identifiant = "Veuillez remplir ce champ.";
      isValid = false;
    } else if (type === "cin" && !/^\d{8}$/.test(identifiant)) {
      errors.identifiant = "Le CIN doit être au format 8 chiffres.";
      isValid = false;
    } else if (type === "extrait" && !/^\d{10}$/.test(identifiant)) {
      errors.identifiant = "L'extrait doit être au format 10 chiffres.";
      isValid = false;
    }

    if (!dateNaissance) {
      errors.dateNaissance = "Veuillez remplir ce champ.";
      isValid = false;
    }

    if (!isValid) {
      form.setFields([
        {
          name: ["apprenants", fieldName, "identifiant"],
          errors: errors.identifiant ? [errors.identifiant] : [],
        },
        {
          name: ["apprenants", fieldName, "dateNaissance"],
          errors: errors.dateNaissance ? [errors.dateNaissance] : [],
        },
      ]);
      return;
    }

    const payload = {
      list_apprenant: [identifiant.toString()],
      id_formation: id_formation,
    };

    const checkExistResponse = await check_apprenant_exist(payload);
    
    if (checkExistResponse.existe && checkExistResponse.existe.length > 0) {
      notification.warning({
        message: t("Avertissement"),
        description: checkExistResponse.existe[0].message,
        duration: 0,
      });
      return;
    }

    if (type === "cin") {
      const value = await checkCitizenStatusByCinDn(identifiant, dateNaissance);
      if (value && value !== false) {
        form.setFieldsValue({
          apprenants: {
            [fieldName]: {
              nom: value?.nomAr,
              prenom: value?.prenomAr,
            },
          },
        });
      }
    } else if (type === "extrait") {
      try {
        const responseMad = await checkCitizenStatusByIdMadDn(identifiant, dateNaissance);
        form.setFieldsValue({
          apprenants: {
            [fieldName]: {
              nom: responseMad?.nom,
              prenom: responseMad?.prenom,
            },
          },
        });
      } catch (error) {
        notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
          duration: 0,
        });
      }
    }
  } catch (error) {
    notification.error({
      message: t("Erreur"),
      description: t(error?.data?.message || "Une erreur est survenue"),
      duration: 0,
    });
  } finally {
    setIsLoading(false);
  }
};
  // const handleSearch = async (fieldName) => {
  //   try {
  //     setIsLoading(true);

  //     const identifiant = form.getFieldValue([
  //       "apprenants",
  //       fieldName,
  //       "identifiant",
  //     ]);
  //     const dateNaissance = form.getFieldValue([
  //       "apprenants",
  //       fieldName,
  //       "dateNaissance",
  //     ]);
  //     const type = form.getFieldValue([
  //       "apprenants",
  //       fieldName,
  //       "typeIdentifiant",
  //     ]);

  //     let isValid = true;
  //     let errors = {};

  //     if (!identifiant) {
  //       errors.identifiant = "Veuillez remplir ce champ.";
  //       isValid = false;
  //     } else if (type === "cin" && !/^\d{8}$/.test(identifiant)) {
  //       errors.identifiant = "Le CIN doit être au format 8 chiffres.";
  //       isValid = false;
  //     } else if (type === "extrait" && !/^\d{10}$/.test(identifiant)) {
  //       errors.identifiant = "L'extrait doit être au format 10 chiffres.";
  //       isValid = false;
  //     }

  //     if (!dateNaissance) {
  //       errors.dateNaissance = "Veuillez remplir ce champ.";
  //       isValid = false;
  //     }

  //     if (!isValid) {
  //       form.setFields([
  //         {
  //           name: ["apprenants", fieldName, "identifiant"],
  //           errors: errors.identifiant ? [errors.identifiant] : [],
  //         },
  //         {
  //           name: ["apprenants", fieldName, "dateNaissance"],
  //           errors: errors.dateNaissance ? [errors.dateNaissance] : [],
  //         },
  //       ]);
  //       return;
  //     }

  //     const payload = {
  //       list_apprenant: [identifiant.toString()],
  //       id_formation: id_formation,
  //     };
  //     check_apprenant_exist(payload)
  //       .then(async () => {
  //         if (type === "cin") {
  //           const value = await checkCitizenStatusByCinDn(
  //             identifiant,
  //             dateNaissance
  //           );
  //           if (value) {
  //             if (value !== false) {
  //               // let lieu_naissance = await getCommuneByCodeCommune(
  //               //   value?.commune
  //               // );

  //               form.setFieldsValue({
  //                 apprenants: {
  //                   [fieldName]: {
  //                     // nom: value?.prenomFr ,
  //                     // prenom: value?.nomFr,
  //                     nom: value?.nomAr,
  //                     prenom: value?.prenomAr,
  //                     // lieuNaissance:lieu_naissance,
  //                     // genre: value?.genre === "2" ? "Mme" : "Mr",
  //                   },
  //                 },
  //               });
  //             }
  //           } else {
  //             setIsLoading(false);
  //           }
  //         }

  //         if (type === "extrait") {
  //           checkCitizenStatusByIdMadDn(
  //             form.getFieldsValue()["num_extrait_naissance"],
  //             form.getFieldsValue()["date_naissance"]
  //           )
  //             .then(async (responseMad) => {
  //               // let lieu_naissance = await getCommuneByCodeCommune(
  //               //   responseMad?.commune
  //               // );

  //               form.setFieldsValue({
  //                 apprenants: {
  //                   [fieldName]: {
  //                     nom: responseMad?.nom,
  //                     prenom: responseMad?.prenom,
  //                     // lieuNaissance:lieu_naissance,
  //                     // genre: responseMad?.genre === "2" ? "Mme" : "Mr",
  //                   },
  //                 },
  //               });
  //             })
  //             .catch((error) => {
  //               notification.error({
  //                 message: t("Erreur"),
  //                 description: t(error?.data?.message),
  //                 duration: 0,
  //               });
  //             });
  //         }
  //       })
  //       .catch((error) => {
  //         notification.error({
  //           message: t("Erreur"),
  //           description: t(error?.data?.message),
  //           duration: 0,
  //         });
  //       });
  //   } catch (error) {
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const disabledBirthDate = (current) => {
    return (
      current && (current > dayjs() || current > dayjs().subtract(15, "year"))
    );
  };

  const columns = [
    {
      title: "Type de l’identifiant",
      dataIndex: "typeIdentifiant",
      width: 120,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "typeIdentifiant"]}
          initialValue="cin"
          rules={[
            { required: true, message: t("Veuillez sélectionner un type.") },
          ]}
        >
          <Select size="small" disabled={id_session_formation}>
            <Option value="cin">CIN</Option>
            <Option value="extrait">Extrait de naissance</Option>
            <Option value="passeport">Passeport</Option>
          </Select>
        </Form.Item>
      ),
    },

    {
      title: "Date de naissance",
      dataIndex: "dateNaissance",
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "dateNaissance"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
        >
          <DatePicker
            size="small"
            locale={locale}
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            disabledDate={disabledBirthDate}
            disabled={id_session_formation}
          />
        </Form.Item>
      ),
    },
    {
      title: "Identifiant",
      dataIndex: "identifiant",
      render: (_, field) => (
        <Form.Item
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.apprenants?.[field.name]?.typeIdentifiant !==
            currentValues.apprenants?.[field.name]?.typeIdentifiant
          }
          noStyle
        >
          {({ getFieldValue }) => {
            const type =
              getFieldValue(["apprenants", field.name, "typeIdentifiant"]) ||
              "cin";

            const rules = [
  {
    validator: (_, value) => {
      if (!value || !value.trim()) {
        return Promise.reject(new Error("Veuillez remplir ce champ."));
      }
      if (type === "cin" && !/^\d{8}$/.test(value)) {
        return Promise.reject(new Error(t("Le CIN doit être au format 8 chiffres.")));
      }
      if (type === "extrait" && !/^\d{10}$/.test(value)) {
        return Promise.reject(new Error(t("L'extrait doit être au format 10 chiffres.")));
      }
      return Promise.resolve();
    },
  },
  {
    validator: (_, value) => {
      if (!value) return Promise.resolve();
      const allValues = getFieldValue("apprenants") || [];
      const currentType = getFieldValue(["apprenants", field.name, "typeIdentifiant"]);
      const isDuplicate = allValues.some((apprenant, idx) => {
        if (idx === field.name) return false;
        return (
          apprenant?.identifiant === value &&
          apprenant?.typeIdentifiant === currentType
        );
      });
      return isDuplicate
        ? Promise.reject(new Error("Identifiant déjà utilisé."))
        : Promise.resolve();
    },
  }
];

            if (type === "cin" || type === "extrait") {
              return (
                <Form.Item
                  {...field}
                  name={[field.name, "identifiant"]}
                  rules={rules}
                >
                  <Search
                    size="small"
                    placeholder=""
                    onSearch={() => handleSearch(field.name)}
                    enterButton
                    disabled={id_session_formation}
                    maxLength={type === "cin" ? 8 : 10}
                  />
                </Form.Item>
              );
            } else {
              return (
                <Form.Item
                  {...field}
                  name={[field.name, "identifiant"]}
                  rules={rules}
                >
                  <Input
                    size="small"
                    placeholder=""
                    disabled={id_session_formation}
                  />
                </Form.Item>
              );
            }
          }}
        </Form.Item>
      ),
    },
    {
      title: "Nom",
      dataIndex: "nom",
      render: (_, field) => (
        <Form.Item
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.apprenants?.[field.name]?.typeIdentifiant !==
            currentValues.apprenants?.[field.name]?.typeIdentifiant
          }
          noStyle
        >
          {({ getFieldValue }) => {
            const type = getFieldValue([
              "apprenants",
              field.name,
              "typeIdentifiant",
            ]);
            const disabled = type === "passeport" ? false : true;

            return (
              <Form.Item
                {...field}
                name={[field.name, "nom"]}
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(t("Veuillez remplir ce champ."));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  size="small"
                  placeholder=""
                  disabled={disabled || id_session_formation}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      ),
    },
    {
      title: "Prénom",
      dataIndex: "prenom",
      render: (_, field) => (
        <Form.Item
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.apprenants?.[field.name]?.typeIdentifiant !==
            currentValues.apprenants?.[field.name]?.typeIdentifiant
          }
          noStyle
        >
          {({ getFieldValue }) => {
            const type = getFieldValue([
              "apprenants",
              field.name,
              "typeIdentifiant",
            ]);
            const disabled = type === "passeport" ? false : true;

            return (
              <Form.Item
                {...field}
                name={[field.name, "prenom"]}
                rules={[
                  { required: true, message: t("Veuillez remplir ce champ.") },
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(t("Veuillez remplir ce champ."));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  size="small"
                  placeholder=""
                  disabled={disabled || id_session_formation}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      ),
    },
    // {
    //   title: "Lieu de naissance",
    //   dataIndex: "lieuNaissance",
    //   render: (_, field) => (
    //     <Form.Item
    //       shouldUpdate={(prevValues, currentValues) =>
    //         prevValues.apprenants?.[field.name]?.typeIdentifiant !== currentValues.apprenants?.[field.name]?.typeIdentifiant
    //       }
    //       noStyle
    //     >
    //       {({ getFieldValue }) => {
    //         const type = getFieldValue(["apprenants", field.name, "typeIdentifiant"]);
    //         const disabled = type === "passeport" ? false : true;

    //         return (
    //           <Form.Item
    //             {...field}
    //             name={[field.name, "lieuNaissance"]}
    //             rules={[
    //               { required: true, message: t("Veuillez remplir ce champ.") },
    //               {
    //                 validator: (_, value) => {
    //                   if (value && value.trim() === "") {
    //                     return Promise.reject(t("Veuillez remplir ce champ."));
    //                   }
    //                   return Promise.resolve();
    //                 },
    //               },
    //             ]}
    //           >
    //             <Input
    //               size="small"
    //               placeholder="Lieu de naissance"
    //               disabled={disabled || id_session_formation}
    //             />
    //           </Form.Item>
    //         );
    //       }}
    //     </Form.Item>
    //   ),
    // },
    // {
    //   title: "Genre",
    //   dataIndex: "genre",
    //   render: (_, field) => (
    //     <Form.Item
    //       shouldUpdate={(prevValues, currentValues) =>
    //         prevValues.apprenants?.[field.name]?.typeIdentifiant !== currentValues.apprenants?.[field.name]?.typeIdentifiant
    //       }
    //       noStyle
    //     >
    //       {({ getFieldValue }) => {
    //         const type = getFieldValue(["apprenants", field.name, "typeIdentifiant"]);
    //         const disabled = type === "passeport" ? false : true;

    //         return (
    //           <Form.Item
    //             {...field}
    //             name={[field.name, "genre"]}
    //             rules={[{ required: true, message: t("Veuillez sélectionner un genre.") }]}
    //           >
    //             <Select
    //               size="small"
    //               placeholder="Genre"
    //               disabled={disabled || id_session_formation}
    //             >
    //               <Option value="M">Masculin</Option>
    //               <Option value="F">Féminin</Option>
    //             </Select>
    //           </Form.Item>
    //         );
    //       }}
    //     </Form.Item>
    //   ),
    // }
    // ,
    typesession === "continue" && {
      title: "Structure / Entreprise",
      dataIndex: "structure",
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "structure"]}
          rules={[
            { required: false },
            {
              validator: (_, value) => {
                if (value && value.trim() === "") {
                  return Promise.reject(t("Veuillez remplir ce champ."));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size="small" placeholder="" disabled={id_session_formation} />
        </Form.Item>
      ),
    },
    {
      title: "Niveau",
      dataIndex: "niveau",
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "niveau"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
        >
          <Select
            style={{ width: "100%" }}
            size="small"
            placeholder="Niveau"
            options={niveauScolaire}
            disabled={id_session_formation}
          />
        </Form.Item>
      ),
    },
  ].filter(Boolean);

  return (
    <ConfigProvider>
      <div>
        <Row className={classes.listeRow}>
          <Card className={classes.listeCard} style={{ marginBottom: "40px" }} bordered={false}>
            <Alert
              type="info"
              style={{ marginTop: "20px" }}
              message="Configuration"
              description={`Ajout des participants`}
              showIcon
            />
            <Form.List name="apprenants">
              {(fields, { add, remove }) => {
                // Synchroniser les champs avec le nombre d'apprenants
                if (fields.length !== nbLignes) {
                  const currentValues = form.getFieldValue('apprenants') || [];
                  const newFields = Array.from({ length: nbLignes }, (_, i) => {
                    return currentValues[i] || { typeIdentifiant: 'cin' };
                  });
                  form.setFieldsValue({ apprenants: newFields });
                }

                return (
                  <Table
                    style={{ marginTop: "20px" }}
                    size="small"
                    dataSource={apprenantsFields}
                    pagination={false}
                    rowKey={(row) => row.key}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                  />
                );
              }}
            </Form.List>
          </Card>
        </Row>
      </div>
    </ConfigProvider>
  );
};

//   return (
//     <ConfigProvider
//       theme={{
//         token: {
//           colorPrimary: "#195A99",
//           lineWidth: 1,
//           fontFamily: "open sans, Helvetica, Arial, sans-serif",
//         },
//         components: {
//           DatePicker: { colorPrimaryHover: "#195A99", fontSize: 13 },

//           Input: {
//             fontSize: 13,
//             colorText: "#000",
//           },
//           Select: {
//             fontSize: 13,
//             colorPrimaryHover: "#195A99",
//           },
//         },
//       }}
//     >
//       <div>
//         <Row className={classes.listeRow}>
//           <Card
//             className={classes.listeCard}
//             style={{ marginBottom: "40px" }}
//             bordered={false}
//           >
//             <Alert
//               type="info"
//               style={{ marginTop: "20px" }}
//               message="Configuration"
//               description={`Ajout des participants`}
//               showIcon
//             />
//             <Form.List name="apprenants">
//               {(fields) => {
//                 if (fields.length !== nbLignes) {
//                   const newFields = Array.from(
//                     { length: nbLignes },
//                     (_, i) => ({
//                       typeIdentifiant: "cin",
//                     })
//                   );
//                   form.setFieldsValue({ apprenants: newFields });
//                 }
//                 return (
//                   <Table
//                     style={{ marginTop: "20px" }}
//                     size="small"
//                     dataSource={apprenantsFields}
//                     pagination={false}
//                     rowKey={(row) => row.key}
//                     columns={columns}
//                     scroll={{ x: "max-content" }}
//                   />
//                 );
//               }}
//             </Form.List>
//           </Card>
//         </Row>
//       </div>
//     </ConfigProvider>
//   );
// };

export default EtapeListeApprenantsFNH;
